export default {
  caixaDeEntrada: [],
  lixeira: []
}
